// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-select[data-v-7b3ec33c] {\n  min-height: 43px;\n}", ""]);
// Exports
module.exports = exports;
